import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const changePassword = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.CHANGE_PASSWORD,
      method: 'put',
      data: data,
    })
      .then((response) => {
        callback && callback(response.data)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
